import { ENUM_ClientUserType } from '@api-new/common';
import { createSelector } from '@ngrx/store';
import { AnalyticsEventMetadataModel } from '@shared/models/analytics-event-metadata.model';
import { selectBestBetterDeals } from '@shared/store/best-better-deals/best-better-deals.selectors';
import { selectClientUser } from '@shared/store/client-user/client-user.selectors';
import { selectMortgageCases } from '@shared/store/mortgage-cases/mortgage-cases.selectors';

export const hasBetterDealWithoutCase = createSelector(selectBestBetterDeals, selectMortgageCases, (bestBetterDeals, mortgageCases) => {
  let hasBetterDealWithoutCase = false;
  bestBetterDeals.forEach((bestBetterDeal) => {
    const hasBetterDealMortgageCase = mortgageCases.find((mortgageCase) => mortgageCase.mortgageId === bestBetterDeal.mortgageId);
    if (!hasBetterDealMortgageCase) {
      hasBetterDealWithoutCase = true;
    }
  });
  return hasBetterDealWithoutCase;
});

export const selectClientUserAnalyticsEventMetadata = createSelector(
  selectClientUser,
  hasBetterDealWithoutCase,
  selectMortgageCases,
  (clientUser, hasBetterDealWithoutCase, mortgageCases): AnalyticsEventMetadataModel => {
    if (!clientUser) {
      return null;
    }
    return {
      clientUserId: clientUser?.id,
      companyId: clientUser?.companyId,
      isLandlord: clientUser?.clientUserType === ENUM_ClientUserType.CLIENT_USER_TYPE_LANDLORD,
      hasBetterDeal: hasBetterDealWithoutCase,
      hasActiveMortgageCase: !!mortgageCases.length,
    };
  },
);
